import { ContentService } from '@blk/cwp-ng-framework';
import { AbstractRenderer, BusinessComponent, BusinessComponentOptions, MultiColumnsBreakableTextComponent } from '@blk/simba';
import { ComponentData } from '@ddt-web/data-service';

export class GlossaryComponent extends BusinessComponent {
	constructor(public dcrKey: string, private numberOfColumns: number, private defaultText?: string, public visible: boolean = true) {
		super(dcrKey, 'GlossaryComponent', BusinessComponentOptions.merge( { visible: visible }));
	}

	public buildComponent(componentData: ComponentData, contentSvc: ContentService): AbstractRenderer<SVGGElement>[] {
		const panels: AbstractRenderer<SVGGElement>[] = [];

		panels.push(new MultiColumnsBreakableTextComponent(this.dcrKey, this.numberOfColumns, this.defaultText));

		return panels;
	}
}
